import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { EditSearchContentWithLoader } from './loaders';
import FaqLanding from './faq';
import { getSearchSettingsById } from '../../../actions/landings';
import { units } from '../../../helpers/styles/units';
import { Tabs } from '../../../components/SiteBody/SiteBodyTabs';

const tabDdata = [
    { name: 'Основные настройки', content: <EditSearchContentWithLoader /> },
    { name: 'FAQ посадочной', content: <FaqLanding /> },
];

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${units(12)};
`;

export const EditSearch = () => {
    const dispatch = useDispatch();
    const [active, setActive] = useState(0);
    const { searchId } = useParams<{ searchId: string }>();

    useEffect(() => {
        dispatch(getSearchSettingsById(searchId));
    }, [dispatch, searchId]);

    return (
        <StyledWrapper>
            <Tabs data={tabDdata} active={active} setActive={setActive} />
        </StyledWrapper>
    );
};
